module.exports = __webpack_public_path__ + "img/20241119-080814.7cc16140.png";